import { Injectable, NgZone } from '@angular/core';

import { User } from "./../model/user";
import { Router } from "@angular/router";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { UtilityService } from './utility.service';
import { Config } from '../model/config';



@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

  public user: User;
  public config: Config;

  constructor(
    public afStore: AngularFirestore,
    public ngFireAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone,
    private utilSrv: UtilityService
  ) {
    this.config = {
      loginDisabled: false,
      qualificazioneDisabled: false,
      tabelloneDisabled: false,
      iscrizioneStop: false,
      allenamentoDisabled: false,
      tournamentId: '1',
      timer: 250,
      timerRecallQuestionPoint: 250,
      googleSession: true,
      soundDisabled: true,
      tournamentBannerDisabled: true
    }

    this.initConfig();
    this.initUser();

    this.ngFireAuth.authState.subscribe(user => {
      if (user && user.emailVerified) {
        this.initRealUser(user);

        //   JSON.parse(localStorage.getItem('user'));
      } else {
        this.initUser();

        // JSON.parse(localStorage.getItem('user'));
      }

    })
  }

  initConfig() {
    this.afStore.collection('configs').snapshotChanges().subscribe(cf => {
      this.config = cf[0].payload.doc.data();
      console.log(this.config)
    });

  }

  initUser() {
    if (!this.user) {
      this.user = JSON.parse(localStorage.getItem('user'));
      if (!this.user) {
        this.user = { displayName: "Anonimo", logged: false, registratoTorneo: false, uid: '111111111', isNickname: false, isUserQualified: false, isGameDone: false, isAdmin: false };
        localStorage.setItem('user', JSON.stringify(this.user));
      }
    }
  }



  initRealUser(user: firebase.User) {

    this.user.logged = true;
    this.user.registratoTorneo = false;
    this.user.uid = user.uid;
    this.user.isNickname = false;
    this.user.isUserQualified = false;
    this.user.isGameDone = false;

    if (user.displayName) {
      this.user.displayName = user.displayName;
    } else {
      this.user.displayName = 'Anonimo';
    }
    this.user.email = user.email;
    this.user.photoURL = user.photoURL;
    this.user.emailVerified = user.emailVerified;
    this.getUser().get().subscribe(doc => {
      let nickname = null;
      if (doc && doc.data()) {
        let data = doc.data();
        nickname = data.nickname;
        if (data.tournamentId) {
          this.user.tournamentId = data.tournamentId;
          this.config.tournamentId = this.user.tournamentId;
        }
        if (data.isAdmin) {
          this.user.isAdmin = data.isAdmin;
        } else {
          this.user.isAdmin = false;
        }

      }

      if (nickname) {
        this.user.displayName = nickname;
      }
      this.utilSrv.hideLoading();
      localStorage.setItem('user', JSON.stringify(this.user));

    }, err => {
      console.log("err", err)
      this.utilSrv.presentGenericModal("Errore", err.message, false)
    });
  }

  getUser(): AngularFirestoreDocument<any> {
    return this.afStore.collection('users').doc(this.user.uid);
  }

  getUserByUuid(uuid: string): AngularFirestoreDocument<any> {
    return this.afStore.collection('users').doc(uuid);
  }
  // Login in with email/password
  SignIn(email, password) {
    return this.ngFireAuth.signInWithEmailAndPassword(email, password);
  }

  // Register user with email/password
  RegisterUser(email, password1, password2) {
    const password = password1 = password2;
    return this.ngFireAuth.createUserWithEmailAndPassword(email, password)
  }

  // Email verification when new user register
  SendVerificationMail() {
    return this.ngFireAuth.currentUser.then((user) => {
      user.sendEmailVerification()
        .then(() => {
          this.router.navigate(['home', 'login']);
        })
    });
  }

  // Recover password
  PasswordRecover(passwordResetEmail) {

    return this.ngFireAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        this.utilSrv.presentGenericModal('Info', 'Ti è stata inviata una mail per il reset password', true)
      }).catch((error) => {
        this.utilSrv.presentGenericModal('Errore', error.message, false);
      })


  }

  // Returns true when user is looged in
  get isLoggedIn(): boolean {
    if (this.user) {
      return this.user.logged;
    }
    this.initUser();

    return this.user.logged;
  }

  set isLoggedIn(val: boolean) {
    this.user.logged = val
  }

  /*
    AuthLogin(provider) {
      return this.ngFireAuth.signInWithPopup(provider)
        .then((result) => {
          this.ngZone.run(() => {
            this.router.navigate(['home']);
          })
          this.SetUserData(result.user);
      }).catch((error) => {
        this.utilSrv.presentGenericModal('Errore',error.message, false);
      })
    }
  
    SetUserData(user) {
      const userRef: AngularFirestoreDocument<any> = this.afStore.doc(`users/${user.uid}`);
      this.initRealUser(user).subscribe(user=>{
        return userRef.set(this.user, {
          merge: true
        })
      });
      
    }
  */
  SignOut() {
    return this.ngFireAuth.signOut().then(() => {
      this.user = {
        displayName: null,
        registratoTorneo: null,
        logged: null,
        isNickname: null,
        isUserQualified: null,
        isGameDone: null,
        isAdmin: null,
        tournamentId: null,
        uid: null,
        email: null,
        photoURL: null,
        emailVerified: null,
      };
      localStorage.removeItem('user');
      this.router.navigate(['home']);
    })
  }

  GetCurrentUserData() {
    return this.ngFireAuth.currentUser;
  }

}